import { useMutation, useQueryClient } from 'react-query';
import { cacheKeys } from './cacheKeys';
import { handleRequest } from '../../../../redux/services/APIService';
import storageHelper from '../../../../libs/storageHelper';
import { toast } from 'react-toastify';

export const useDeleteTopic = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (data) => {
      const { user } = storageHelper.getFromStorage('loggedUser');
      return handleRequest(
        'delete',
        `facility/${user.facility}/topics/${data._id}`,
        true,
      );
    },
    {
      onSuccess: async () => {
        toast('Topic was successfully deleted', {
          type: 'success',
          style: { width: 'auto' },
        });
        queryClient.invalidateQueries(cacheKeys.getTopics());
      },
      onError: async (err) => {
        toast('Unable to delete Topic', {
          type: 'error',
          style: { width: 'auto' },
        });
        console.error(
          `Failed to delete Topic: ${
            err.response?.data.message || err.message
          }`,
        );
      },
    },
  );

  return mutation;
};
